import { render, staticRenderFns } from "./in.vue?vue&type=template&id=5fc0e3b6&scoped=true&"
import script from "./in.vue?vue&type=script&lang=js&"
export * from "./in.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc0e3b6",
  null
  
)

export default component.exports